module.exports = __webpack_public_path__ + "media/img/vca/nomf1-370e06f4e2ceaeac9ffee06c2b832279.png";